import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
const BASE_URl = window.location.origin

const initialState = {
  isLoading: false,
  isError: false,
  Error: null,
  foods: null,
  showItems: null,
  category: 'Special Offers & Deals',
  viewFood: null
};

export const fetchFoods = createAsyncThunk('food/fetchFoods', async()=>{
  const res = await fetch(`${BASE_URl}/api/showfoods`)
  const data = await res.json()
  return data
})

const foodSlice = createSlice({
  name: 'food',
  initialState,
  reducers: {
    showFood: (state, action) => {
      const items = state.foods.filter((item) => item.category === action.payload)
      state.showItems = items
      state.category = action.payload
    },
    viewFood: (state, action) => {
      state.viewFood = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchFoods.pending, (state) => {
      state.isLoading = true
    })
    .addCase(fetchFoods.fulfilled, (state, action) => {
      state.isLoading = false
      state.category = 'Special Offers & Deals'
      const foods = action.payload.foods
      state.foods = foods
      state.showItems = foods.filter((item) => item.category === 'Special Offers & Deals')

    })
    .addCase(fetchFoods.rejected, (state, action) => {
      state.isError = true
      state.Error = action.error.message || 'Something Went Wrong'
    })
  }
});

export const {showFood, viewFood} = foodSlice.actions

// Export reducer
export default foodSlice.reducer;
